import React from 'react'
import type { DropdownSelectOption, DropdownSelectProps, SingleSelectProps } from '../DropdownSelect'
import DropdownSelect from '../DropdownSelect'
import moment from 'moment'

interface TimeSelectProps extends Omit<DropdownSelectProps, 'value'> {
  value: number
  startAt?: number // 0-23, moves this hour to the top and wraps earlier hours to the bottom
}

export function TimeSelect({ value, startAt, ...props }: TimeSelectProps) {
  const options = generateTimeOptions(value || Date.now(), { startAt })

  const selectedValues: DropdownSelectOption[] = value
    ? options.filter((option) => {
        return value === option.value.valueOf()
      })
    : []

  const singleSelectProps = { ...props, value: selectedValues[0], variant: 'single' } as SingleSelectProps

  return (
    <div style={{ width: '100%' }}>
      <DropdownSelect searchable {...singleSelectProps} disabled={props.disabled} options={options} />
    </div>
  )
}

export default TimeSelect

export function generateTimeOptions(value: number, { startAt }: { startAt?: number } = {}): DropdownSelectOption[] {
  const timeOptions: DropdownSelectOption[] = []
  const today = moment(value).startOf('day')
  const startSlot = startAt != null ? startAt * 2 : 0
  for (let i = 0; i < 48; i++) {
    const slot = (startSlot + i) % 48
    const time = today.clone().add(slot * 30, 'minutes')
    const value = time.toDate()
    const label = time.format('h:mma')
    timeOptions.push({ value, label })
  }
  return timeOptions
}
